export default __webpack_public_path__ + "static/media/BW-Group841.af4de700.svg";